export interface SortFieldDisplayProps {
  label: string;
  sortKey: string;
  sortDirection: SortDirection;
}

export type SortingOptions = { headerKey: string; sortKey: string; sortDir: SortDirection; label?: string };

export interface SortState extends SortFieldDisplayProps {
  headerKey: string;
}
export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
}
